import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataView } from 'primeng/dataview';

@Component({
    selector: 'thumbs',
    templateUrl: 'thumbs.component.html',
    styleUrls: ['thumbs.component.scss'],
})
export class ThumbsComponent {
    @Input() public thumbSize;
    @Input() public thumbList;
    @Input() public infoList;
    @Input() public currentUser;
    @Input() public hasLock;
    @Output() public clickImg = new EventEmitter<any>();

    public listColumns: any[];
    @ViewChild('dv') public dataTableUse: DataView;

    public selectedList: any[];

    constructor(private translate:TranslateService) {
        this.selectedList = new Array();
    }

    public onClickImg(adatathumbList) {
        this.clickImg.emit({
            data: adatathumbList,
        });
    }

    public onSelectThumb(event, aData) {
        if (event.selected === false) {
            this.selectedList = this.selectedList.filter((item) => {
                return item.doc_docid !== aData.doc_docid;
            });
        } else {
            if (this.findSelected(aData) === undefined) {
                this.selectedList.push(aData);
            }
        }
    }

    private findSelected(data) {
        return this.selectedList.find((item) => {
            return item.doc_docid === data.doc_docid;
        });
    }

    public onSelectAll(event) {
        if (event.checked === true) {
            this.setSelected(true);
        } else {
            this.setSelected(false);
        }
    }

    public ngOnInit() {
        let wItem;
        let wName;
        this.listColumns = [{ field: 'doc_docid', header: this.translate.instant('Doc_B')}];
        this.selectedList = [];
        this.thumbList.map((item) => {
            this.updateSelectedList(item);
            item.info = [];
            this.infoList.map((elem) => {
                wName = elem.name.replace('&', '');
                if (item.hasOwnProperty(wName)) {
                    wItem = new Object();
                    wItem.name = elem.label;
                    wItem.value = item[wName];
                    item.info.push(wItem);
                }
            });
        });
    }

    public ngOnChanges() {}

    public setFirst(aValue) {
        this.dataTableUse.first = aValue;
    }

    public updateSelectedList(aItem) {
        let wItem;
        wItem = new Object();
        wItem.doc_docid = aItem.doc_docid;
        wItem.doc_name = aItem.doc_name;
        wItem.selected = false;
        this.selectedList.push(wItem);
    }

    public remove(id) {
        this.thumbList = this.thumbList.filter((item) => {
            return item.doc_docid !== id;
        });
    }

    public getSelectedCount() {
        let wCount = 0;
        this.selectedList.map((item) => {
            if (item.selected === true) {
                wCount++;
            }
        });
        return wCount;
    }

    private setSelected(aValue) {
        this.selectedList.map((item) => {
            item.selected = aValue;
        });
    }
}
